export const types = {
  state: {
    isAuthenticated: 'auth/isAuthenticated',
    user: 'auth/userInfo',
    appConfigSettings: 'auth/appConfigSettings',
    appUser: 'auth/appUser',

    syncUpCounts: 'meals/syncUpCounts',
    mealCountDtos: 'meals/mealCountDtos',
    mealCountStatuses: 'meals/mealCountStatuses',
    lastSyncUtc: 'meals/lastSyncUtc',
    tempDto: 'meals/tempDto',
    mergeServingLines: 'meals/mergeServingLines',

    selectedSponsor: 'counter/selectedSponsor',
    selectedSite: 'counter/selectedSite',
    sites: 'counter/sites',
    featureFlags: 'counter/featureFlags',
    sponsors: 'counter/sponsors',
    programs: 'counter/programs',
    siteAppDates: 'counter/siteAppDates',
    pwaInstalled: 'counter/pwaInstalled',
    isOnline: 'counter/isOnline',
    isSyncing: 'counter/isSyncing',
    selectedSponsorId: 'counter/selectedSponsorId',
    selectedSiteId: 'counter/selectedSiteId',
    selectedProgramId: 'counter/selectedProgramId',
    selectedMealDate: 'counter/selectedMealDate',
    timeStamp: 'counter/timeStamp'
  },
  mutations: {
    updateAuthState: 'auth/updateAuthStatus',
    updateUserInfo: 'auth/updateUserInfo',
    updateAppSettings: 'auth/updateAppSettings',

    updateSyncDate: 'meals/updateSyncDate',
    updateCountDto: 'meals/updateCountDto',
    updateCountStatus: 'meals/updateCountStatus',
    updateTempDto: 'meals/updateTempDto',
    updateMergeServingLines: 'meals/updateMergeServingLines',

    updateSites: 'counter/updateSites',
    updateFeatureFlags: 'counter/updateFeatureFlags',
    updateSponsors: 'counter/updateSponsors',
    updatePwaInstalled: 'counter/updatePwaInstalled',
    updateIsOnline: 'counter/updateIsOnline',
    updateIsSyncing: 'counter/updateIsSyncing',
    updateSponsorId: 'counter/updateSponsorId',
    updateSiteId: 'counter/updateSiteId',
    updateProgramId: 'counter/updateProgramId',
    updateSelectedMealDate: 'counter/updatedSelectedMealDate',
    updateTimeStamp: 'counter/updateTimeStamp'
  },
  actions: {
    setAuth: 'auth/setAuth',
    setAppSettings: 'auth/setAppSettings',

    updateSyncDates: 'meals/updateSyncDates',
    updateCountDto: 'meals/updateCountDto',
    updateRequestToSyncUp: 'meals/updateRequestToSyncUp',
    updateMultipleCountDtos: 'meals/updateMultipleCountDtos',
    updateCountStatuses: 'meals/updateCountStatuses',
    setTempDto: 'meals/setTempDto',
    clearSyncUp: 'meals/clearSyncUp',
    updateMergeServingLines: 'meals/updateMergeServingLines',
    clearServingLines: 'meals/clearServingLines',

    setSites: 'counter/setSites',
    setFeatureFlags: 'counter/setFeatureFlags',
    setSponsors: 'counter/setSponsors',
    setPrograms: 'counter/setPrograms',
    setSiteAppDates: 'counter/setSiteAppDates',
    setSiteAppNonCongregateMeals: 'counter/setSiteAppNonCongregateMeals',
    setPwaInstalled: 'counter/setPwaInstalled',
    setIsOnline: 'counter/setIsOnline',
    setIsSyncing: 'counter/setIsSyncing',
    setSelectedSponsorId: 'counter/setSelectedSponsorId',
    setSelectedSiteId: 'counter/setSelectedSiteId',
    setSelectedProgramId: 'counter/setSelectedProgramId',
    setSelectedMealDate: 'counter/setSelectedMealDate',
    setTimeStamp: 'counter/setTimeStamp'
  }
};
